import { render, staticRenderFns } from "./Wfo_seating.vue?vue&type=template&id=a15b7168&"
import script from "./Wfo_seating.vue?vue&type=script&lang=js&"
export * from "./Wfo_seating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports